<template>
  <div class="quick-entry">
    <div
      :class="['btn-icon',{'hover':btnHover}]"
      @mouseenter="handleEntry(true)"
      @mouseleave="handleLeave(false)"
      @click="handleBtnClick(false)"
    >
      <img
        :src="btnIcon"
        alt=""
      >
      <transition name="el-zoom-in-bottom">
        <ul
          class="btn-list"
          v-show="btnActive"
        >
          <li
            class="item"
            v-for="(item,index) in btnList"
            :key="index"
          >
            <div
              class="box"
              @mouseenter="()=>item.hover = true"
              @mouseleave="()=>item.hover = false"
              @click="handleItemClick(item)"
            >
              <img
                :src="item.url"
                alt=""
              >
              <transition name="el-zoom-in-top">
                <div
                  class="label-box"
                  v-show="item.hover"
                >
                  <div class="label">
                    {{$t(item.label)}}
                  </div>
                </div>
              </transition>

            </div>

          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>
<script>
import { routerIconList } from '@/utils/enum/index'

export default {
  data () {
    const routerList = [
      // 20210705, // 企业理财
      // 20200901, // 货币兑换
      // 20210427, // 欧美电商提款
      // 10200300, // 跨行汇款
      // 10200000, // 同行汇款
      // 10100100 // 交易明细

      10200300, // 跨行汇款
      10200000, // 同行汇款
      10101300, // 汇入汇款申报
      10100101, // 汇入路径查询
      10100100, // 交易明细
      10102500 // 货币兑换
    ]
    return {
      btnActive: false,
      btnHover: false,
      btnList: routerList.map(item => {
        return {
          ...routerIconList[item],
          hover: false
        }
      })
    }
  },
  computed: {
    btnIcon () {
      return this.btnActive ? require('@/assets/image/quickentry/close.png') : require('@/assets/image/quickentry/default.png')
    }
  },
  methods: {
    handleEntry () {
      this.setBtnHover(true)
      this.handleBtnClick(true)
    },
    handleLeave () {
      this.setBtnHover(false)
      this.handleBtnClick(false)
    },
    setBtnHover (type) {
      this.btnHover = type
    },

    handleBtnClick (type) {
      this.btnActive = type
    },
    handleItemClick (item) {
      if (!item.name) {
        this.$warn('敬请期待')
        return
      }
      this.$router.push({
        name: item.name
      })
    }
  }
}
</script>
<style lang="less" scoped>
img {
  display: block;
}
.quick-entry {
  position: fixed;
  right: 30px;
  bottom: 250px;
  width: 50px;
  // height: 152px;
  background: #ffffff;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 25px;
  z-index: 9;
  .btn-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background: linear-gradient(180deg, #92abff 0%, #4a6aff 100%);
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 25px;
    border: 1px solid #ffffff;
    cursor: pointer;
    &.hover {
      background: linear-gradient(180deg, #4a6aff 0%, #92abff 100%);
    }
    img {
      width: 40px;
      height: 40px;
    }
  }
  .btn-list {
    position: absolute;
    bottom: 50px;
    right: 0;
    left: 0;
    .item {
      width: 50px;
      height: 50px;
      background: #f6f7fc;
      box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 25px;
      border: 1px solid #ffffff;
      margin-bottom: 10px;
      .box {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        &:hover {
          background: @white;
        }
        .label-box {
          position: absolute;
          right: 45px;
          top: 50%;
          transform: translateY(-50%);
          padding-right: 25px;
          .label {
            position: relative;
            min-width: 130px;
            padding: 13px 15px;
            background: #ffffff;
            box-shadow: 0px 1px 14px 2px rgba(0, 0, 0, 0.04);
            text-align: left;
            font-weight: 400;
            border-radius: 4px;
            white-space: nowrap;
            color: @black;
            .text {
              font-size: 14px;
              font-weight: 300;
              color: #5a607f;
              line-height: 14px;
            }
            &::after {
              position: absolute;
              right: -9px;
              top: 50%;
              transform: translate(0, -50%) rotate(45deg);
              content: '';
              width: 18px;
              height: 18px;

              background: #fff;
              background-size: 16px 16px;
              border-top-right-radius: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
